export default {
  "name": "sbm",
  "api": "https://api.sbm.proapp.fi",
  "chat_api": "https://chat-sbm.proapp.fi",
}



